import { vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9ea933aa")

_pushScopeId("data-v-9ea933aa")
const _hoisted_1 = { class: "checkbox__input" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "checkbox__control" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("label", {
    class: [{'inline': _ctx.inline}, "checkbox"]
  }, [
    _createVNode("span", _hoisted_1, [
      _withDirectives(_createVNode("input", _mergeProps({
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.internalValue = $event)),
        value: _ctx.value,
        type: "checkbox"
      }, _ctx.$attrs), null, 16, ["value"]), [
        [_vModelCheckbox, _ctx.internalValue]
      ]),
      _hoisted_2
    ]),
    _createVNode("span", {
      class: "checkbox__label",
      textContent: _toDisplayString(_ctx.label)
    }, null, 8, ["textContent"])
  ], 2))
})